import React from 'react'

function SurveyDosen() {
  return (
    <div>SurveyDosen</div>
  )
}

export default SurveyDosen